export function getDisplayCodeFromUrl(): string | null {
  const match = window.location.pathname.match(/^\/([^/]+)\/?$/);
  return match ? match[1] : null;
}
